<div
    class="tw-hidden md:tw-flex tw-justify-between tw-flex-wrap tw-w-full tw-border-b-2 tw-border-solid tw-border-caption-gray tw-border-opacity-10 md:tw-border-opacity-25"
>
    <div class="tw-flex">
        <button
            class="tw-text-lg tw-py-[25px]  tw-font-semibold tw-px-[33px] tw-cursor-pointer tw-border-b-2 {{
                activeTab == 'applications'
                    ? 'tw-border-black'
                    : 'tw-border-transparent tw-text-caption-gray'
            }} tw-border-solid tw-relative -tw-bottom-[1px]"
            routerLink="/applications"
        >
            {{ "COMMON.RECENT" | translate }}
        </button>

        <button
            class="tw-text-lg tw-py-[25px] tw-font-semibold tw-px-[33px] tw-cursor-pointer tw-border-b-2 tw-border-solid {{
                activeTab == 'past-applications'
                    ? 'tw-border-black'
                    : 'tw-border-transparent tw-text-caption-gray'
            }} tw-relative -tw-bottom-[1px]"
            routerLink="/past-applications"
        >
            {{ "COMMON.PAST" | translate }}
        </button>

        <button
            class="tw-text-lg tw-py-[25px] tw-text-caption-gray tw-font-semibold tw-px-[33px] tw-cursor-pointer tw-border-b-2 tw-border-solid {{
                activeTab == 'draft'
                    ? 'tw-border-black'
                    : 'tw-border-transparent tw-text-caption-gray'
            }} tw-relative -tw-bottom-[1px]"
            routerLink="/draft"
        >
            {{ "COMMON.DRAFT" | translate }}
        </button>
    </div>
    <div class="tw-relative">
        <button
            class="tw-text-[12px] tw-text-white md:tw-text-[14px] lg:tw-text-[12px] xl:tw-text-[16px] tw-py-[22px] tw-font-semibold tw-px-[52px] md:tw-px-[60px] tw-rounded-full tw-bg-[#FFA53C]"
            routerLink="/business-financing"
        >
            {{ "COMMON.NEW" | translate }}
        </button>
    </div>
</div>

<!-- mobile -->
<div class="tw-block md:tw-hidden">
    <div class="tw-text-base tw-font-semibold tw-text-caption-gray tw-pb-2">
        Category
    </div>
    <select-general
        class="tw-w-full"
        [options]="applicationNav"
        [label]="''"
        [placeHolder]="'NEW_APPLICATION.DROPDOWN_PLACEHOLDER' | translate"
        [currentValue]="activeTab"
        [controlName]="'businessType'"
        (selectionChange)="onSelectionChange($event)"
    />
</div>

<div
    class="tw-mt-6 tw-px-8 tw-py-6 tw-rounded-2xl tw-flex tw-flex-col-reverse md:tw-flex-row md:tw-justify-between app-header-bg"
>
    <div class="tw-text-base tw-font-semibold tw-text-[#003A70]">
        {{ "COMMON.FURTHER_ENQ" | translate }}<br class="md:tw-hidden" />
        <span class="tw-font-extrabold md:tw-font-bold">03-7880 0088</span>
    </div>
    <div
        class="tw-text-xs md:tw-text-lg tw-text-[#003A70] tw-font-semibold tw-pb-2 md:tw-pb-0"
    >
        {{ "COMMON.REFFERED" | translate }}
    </div>
</div>

<div class="tw-flex tw-justify-center md:tw-hidden tw-mt-4 tw-mb-10">
    <button
        class="tw-text-[12px] tw-text-white md:tw-text-[14px] lg:tw-text-[12px] xl:tw-text-[16px] tw-py-[22px] tw-font-semibold tw-px-[52px] md:tw-px-[60px] tw-rounded-full tw-bg-[#FFA53C]"
        routerLink="/business-financing"
    >
        {{ "COMMON.NEW" | translate }}
    </button>
</div>
